import palette from '../palette';

export default {
  root:{
    backgroundColor: palette.colors.grey[500],
  },
  outlined:{
    border:' 0.5px solid #828D9E'
  },
  elevation1: {
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'
  },
  elevation2:{
      background: '#1C1F24 !important',
      border: '0.5px solid #404150 !important',
      boxShadow: 'unset',
      borderRadius: '8px !important'
  },
  elevation3:{
    borderRadius: 8,
    border: '0.5px solid #404150',
    background: '#111'
  }
};
